'use client';
import { createContext, useContext } from 'react';

export type MenuLayoutContextValue = {
  closeMenu?: () => void;
  collapsedMenu?: boolean;
  setCollapsedMenu?: (_: boolean) => void;
};

/**
 * Drawer state shared by MenuLayout with its menu. The menu element comes from a server layout and reaches
 * the client as an opaque (possibly lazy) node, so these can't be injected as props with cloneElement.
 */
export const MenuLayoutContext = createContext<MenuLayoutContextValue>({});

export const useMenuLayout = () => useContext(MenuLayoutContext);
